// extracted by mini-css-extract-plugin
export var columnList = "_ga-0";